import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extranjeria-landing',
  templateUrl: './extranjeria-landing.component.html',
  styleUrls: ['./extranjeria-landing.component.css']
})
export class ExtranjeriaLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }
  
  goToWebapp(){
    window.open('https://app.voyjaleas.com/#/sub-app/health-helper');
  }

}
